module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section07_04_american-village-d719f894d1c467bf1d56ea6141ed16f1.jpg";